export const FETCH_TRAININGS_REQUEST = 'FETCH_TRAININGS_REQUEST'
export const FETCH_TRAININGS_SUCCESS = 'FETCH_TRAININGS_SUCCESS'
export const FETCH_TRAININGS_FAILURE = 'FETCH_TRAININGS_FAILURE'

export const SAVE_TRAINING_REQUEST = 'SAVE_TRAINING_REQUEST'
export const SAVE_TRAINING_FAILURE = 'SAVE_TRAINING_FAILURE'
export const SAVE_TRAINING_SUCCESS = 'SAVE_TRAINING_SUCCESS '
